import React, { useState } from "react";
import {
  Outlet,
  Link as RouterLink,
  useParams,
  useLocation,
} from "react-router-dom";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { useQuery } from "react-query";
import { getCurrentPathTab } from "../services/Utils";
import  { getVehicleModelById }  from "../services/vehicle";
import BreadCrumbsRendered from "../components/BreadCrumbsRendered";
import VehicleModelDetailsTab from "../components/vehicle/model/VehicleModelDetailsTab";
import VehicleModelTrimsTab from "../components/vehicle/model/VehicleModelTrimsTab";

const PATHS = ["overview", "trims"];

const VehicleModel = () => {
  const { modelId = "" } = useParams();
  const { pathname } = useLocation();
  const [value, setValue] = useState(
    getCurrentPathTab(pathname, PATHS, "overview")
  );

  const { data: { data: modelData } = {}, isLoading } = useQuery(
    ["vehicleModelDetails", modelId],
    getVehicleModelById,
    {
      refetchOnWindowFocus: false,
    }
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const notifyLinkClick = (toPath) => {
    setValue(getCurrentPathTab(toPath, PATHS, "overview"));
  };

  const commonProps = {
    modelData,
    modelDataLoading: isLoading,
    isLoading,
    modelId,
  };

  return (
    <div className="fragmentContainer">
      <BreadCrumbsRendered
        pathname={pathname}
        notifyLinkClick={notifyLinkClick}
      />
      <Box
        sx={{ width: "100%", marginTop: 4, padding: "2%" }}
        component={Paper}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs onChange={handleChange} value={value} variant="scrollable">
            <Tab
              label="Overview"
              value={"overview"}
              component={RouterLink}
              to={"overview"}
            />
            <Tab
              label="Trims"
              value={"trims"}
              component={RouterLink}
              to={"trims"}
            />
          </Tabs>
        </Box>
        <div className="tabs-container">
          <Routes>
            <Route
              path="/"
              element={<VehicleModelDetailsTab {...commonProps} />}
            />
            <Route
              path="overview"
              element={<VehicleModelDetailsTab {...commonProps} />}
            />
            <Route
              path="trims"
              element={<VehicleModelTrimsTab {...commonProps }  modelName={modelData?.name}/>}
            />
          </Routes>
          <Outlet />
        </div>
      </Box>
    </div>
  );
};

export default VehicleModel;